import { render, staticRenderFns } from "./NewAddPointsAction.vue?vue&type=template&id=5bf0aa18&scoped=true&"
import script from "./NewAddPointsAction.vue?vue&type=script&lang=js&"
export * from "./NewAddPointsAction.vue?vue&type=script&lang=js&"
import style1 from "./NewAddPointsAction.vue?vue&type=style&index=1&id=5bf0aa18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0aa18",
  null
  
)

export default component.exports